// Which strategy Motivation Moment shows: a new one each part of the day (morning, afternoon, evening), stepping
// through the list in order, so the next part of the day never repeats the last and every strategy comes round
// before any comes back. Until 24 Oct 2026 it was a hash of the date, which could show the same one all day.
// `slot` is 0, 1 or 2; the day counts from the local calendar date, so it turns over at midnight.
export const SLOTS_PER_DAY = 3;

export function motivationIndex(date, slot, count) {
  if (!count) return -1;
  const day = Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000);
  return (day * SLOTS_PER_DAY + slot) % count;
}
